module.exports = __webpack_public_path__ + "static/img/28.3b4f2f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/28.png
// module id = Q8iR
// module chunks = 0